import React, { useEffect, useState } from "react";
import "../style/homeCategory.css";
import { Link } from "react-router-dom";
import { getcategory } from "../service/category.service";
import { getlistingUrl } from "../../../utils/url.utils";
import comingsoon from "../../../assets/images/comingsoon.jpg"

export default function HomeCategory() {
  const [categoryItems, setCategoryItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      setLoading(true);
      const response = await getcategory();
      const data = response.map((item) => ({
        id: item.id,
        title: item.title,
        alt: item.media?.[0]?.altText || item.title,
        src: item.media?.[0]?.image,
        buttonUrl: item.buttonUrl || item.slug,
      }));

      setCategoryItems(data);
    } catch (error) {
      console.error("Category fetch error:", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <section className="category-section mt-2">
        <div className="container text-center">
          Loading...
        </div>
      </section>
    );
  }

  if (!categoryItems.length) {
    return null;
  }

  return (
    <section className="category-section mt-2">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12 text-center">
            <h2> Categories </h2>
            <div className="border-bootemline"></div>
          </div>
        </div>

        <div className="row g-3">
  {categoryItems.map((item) => (
    <div className="col-12 col-md-6 col-lg-6 col-xl-4" key={item.id}>
      <div
        className="relative overflow-hidden border-radius-44"
        style={{
          borderRadius: "4px",
          height: "100%",
        }}
      >
        <Link to={getlistingUrl(item.buttonUrl)}>
          <img
            src={item.src}
            alt={item.alt}
            className="w-100 h-100 object-cover transition duration-300 ease-in-out hover:scale-105"
            style={{
              objectFit: "cover",
            }}
          />
        </Link>
      </div>
    </div>
  ))}

  {/* 9th Image - Coming Soon */}
<div className="col-12 col-md-6 col-lg-6 col-xl-3">
  <Link
    to={getlistingUrl("/coming-soon/items")}
    className="coming-soon-card"
  >
    <img
      src={comingsoon}
      alt="Coming Soon"
      className="w-100 h-100 object-cover coming-soon-card__image"
    />

    <div className="coming-soon-card__shine"></div>
  </Link>
</div>
</div>
      </div>
    </section>
  );
}